import styled from '@emotion/styled';

export const EmptyPlayersMessageContainer = styled.div`
  font-family: 'SF Pro Display', sans-serif;
  color: #8F8E99;
  text-align: center;
`;
